/* =============================================================
   Burns Music Library — chopd mini
   assets/chopd-mini.js
   Self-contained. Wrapped in an IIFE. All lookups scoped to
   #db-product so nothing collides with the theme.
   Handles: per-chop audio players + progress bars, click/drag seek,
   one-at-a-time playback, a sticky "now playing" bar, and the
   limited-availability countdown.
   ============================================================= */
(function () {
  "use strict";

  var root = document.getElementById("db-product");
  if (!root) return;


  /* ---------- helpers ---------- */
  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ":" + (s < 10 ? "0" : "") + s;
  }

  function svgIcon(cls, path) {
    return (
      '<svg class="' + cls + '" viewBox="0 0 24 24" aria-hidden="true">' +
      path +
      "</svg>"
    );
  }
  var PLAY_PATH = '<path fill="currentColor" d="M8 5v14l11-7z"/>';
  var PAUSE_PATH =
    '<path fill="currentColor" d="M6 5h4v14H6zm8 0h4v14h-4z"/>';

  /* ---------- sticky now-playing bar ---------- */
  var nowBar = root.querySelector(".dbp-now");
  var nowName = root.querySelector(".dbp-now__name");
  var nowFill = root.querySelector(".dbp-now__fill");
  var nowTime = root.querySelector(".dbp-now__time");
  var nowBtn = root.querySelector(".dbp-now__btn");

  var current = null; // the chop object currently loaded into the bar

  function showNow(chop) {
    if (!nowBar) return;
    current = chop;
    nowName.textContent = chop.name;
    nowBar.classList.add("is-visible");
  }
  function syncNowState(playing) {
    if (!nowBar) return;
    nowBar.classList.toggle("is-paused", !playing);
  }
  if (nowBtn) {
    nowBtn.addEventListener("click", function () {
      if (!current) return;
      if (current.audio.paused) current.play();
      else current.pause();
    });
  }

  /* ---------- build a chop player ---------- */
  var chops = [];

  function stopOthers(except) {
    chops.forEach(function (c) {
      if (c !== except) c.pause();
    });
  }

  function buildChop(el) {
    var url = el.getAttribute("data-url");
    if (!url) return;

    var nameEl = el.querySelector(".dbp-chop__name");
    var timeEl = el.querySelector(".dbp-chop__time");
    var playBtn = el.querySelector(".dbp-play");
    var seek = el.querySelector(".dbp-seek");
    var fill = el.querySelector(".dbp-seek__fill");

    var audio = null;
    var chop = {
      el: el,
      name: nameEl ? nameEl.textContent.trim() : "Chop",
      audio: null,
      play: play,
      pause: pause,
    };

    var pendingFrac = null;

    function ensureAudio() {
      if (audio) return audio;
      audio = new Audio(url);
      audio.preload = "metadata";
      chop.audio = audio;
      audio.addEventListener("timeupdate", onTime);
      audio.addEventListener("loadedmetadata", onTime);
      audio.addEventListener("ended", onEnded);
      return audio;
    }

    function paint(frac) {
      if (fill) fill.style.width = Math.max(0, Math.min(1, frac)) * 100 + "%";
    }

    function onTime() {
      var d = audio.duration || 0;
      if (pendingFrac != null && d) {
        audio.currentTime = pendingFrac * d;
        pendingFrac = null;
      }
      var frac = d ? audio.currentTime / d : 0;
      paint(frac);
      if (timeEl) {
        timeEl.textContent = d
          ? fmt(audio.currentTime) + " / " + fmt(d)
          : fmt(audio.currentTime);
      }
      if (current === chop && nowFill) {
        nowFill.style.width = frac * 100 + "%";
        if (nowTime) nowTime.textContent = fmt(audio.currentTime);
      }
    }

    function onEnded() {
      el.classList.remove("is-playing");
      paint(0);
      if (timeEl && audio.duration) timeEl.textContent = fmt(audio.duration);
      syncNowState(false);
    }

    function play() {
      stopOthers(chop);
      ensureAudio();
      audio.play().catch(function () {});
      el.classList.add("is-playing");
      showNow(chop);
      syncNowState(true);
    }

    function pause() {
      if (!audio) return;
      audio.pause();
      el.classList.remove("is-playing");
      if (current === chop) syncNowState(false);
    }

    if (playBtn) {
      playBtn.addEventListener("click", function () {
        if (audio && !audio.paused) pause();
        else play();
      });
    }

    // click / drag to seek
    if (seek) {
      var seeking = false;
      function seekTo(clientX) {
        var rect = seek.getBoundingClientRect();
        if (!rect.width) return;
        var frac = (clientX - rect.left) / rect.width;
        frac = Math.max(0, Math.min(1, frac));
        ensureAudio();
        if (audio.duration) {
          audio.currentTime = frac * audio.duration;
          onTime();
        } else {
          pendingFrac = frac; // apply once metadata loads
          paint(frac);        // immediate visual feedback
          audio.load();
        }
      }
      seek.addEventListener("pointerdown", function (e) {
        seeking = true;
        seek.setPointerCapture && seek.setPointerCapture(e.pointerId);
        seekTo(e.clientX);
      });
      seek.addEventListener("pointermove", function (e) {
        if (seeking) seekTo(e.clientX);
      });
      seek.addEventListener("pointerup", function () {
        seeking = false;
      });
      seek.addEventListener("pointercancel", function () {
        seeking = false;
      });
    }

    chops.push(chop);
  }

  var chopEls = root.querySelectorAll(".dbp-chop");
  for (var c = 0; c < chopEls.length; c++) buildChop(chopEls[c]);

  /* ---------- add to cart (stays on page; opportunistic native cart UI) ---------- */
  var buyForm = root.querySelector(".dbp-buy form");
  if (buyForm) {
    var atc = buyForm.querySelector(".dbp-atc");
    var idInput = buyForm.querySelector('[name="id"]');
    buyForm.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!atc || atc.disabled) return;
      var variantId = idInput && idInput.value;
      var label = atc.textContent;
      atc.disabled = true;
      atc.textContent = "Adding\u2026";

      // Opportunistically find the theme's cart UI (Spotlight/Dawn style).
      var cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      var canRender =
        cart &&
        typeof cart.getSectionsToRender === "function" &&
        typeof cart.renderContents === "function";

      var fd = new FormData();
      fd.append("id", variantId);
      fd.append("quantity", "1");
      if (canRender) {
        try {
          fd.append("sections", cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append("sections_url", window.location.pathname);
          if (typeof cart.setActiveElement === "function") cart.setActiveElement(document.activeElement);
        } catch (err) {
          canRender = false;
        }
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" },
        body: fd,
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (res) {
          if (res && res.status) {
            throw new Error(res.description || res.message || "add failed");
          }
          atc.textContent = "Added \u2713";

          // Native drawer/notification if the theme exposes it; else quiet count bump.
          var rendered = false;
          if (canRender) {
            try {
              cart.renderContents(res);
              rendered = true;
            } catch (err) {
              rendered = false;
            }
          }
          if (!rendered) refreshCartCount();

          // Nudge the theme's own listeners (guarded — silently skips if absent).
          try {
            if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: "chopd-mini",
                productVariantId: variantId,
                cartData: res,
              });
            }
          } catch (err) {}

          setTimeout(function () {
            atc.textContent = label;
            atc.disabled = false;
          }, 1800);
        })
        .catch(function (err) {
          console.error("[chopd-mini] add to cart failed:", err && err.message, "| variant id:", variantId);
          atc.textContent = "Try again";
          setTimeout(function () {
            atc.textContent = label;
            atc.disabled = false;
          }, 1800);
        });
    });
  }

  function refreshCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var count = cart.item_count;
        var sels = [
          ".cart-count",
          "[data-cart-count]",
          ".cart-count-bubble span",
          ".header__cart-count",
          "#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']",
        ];
        sels.forEach(function (s) {
          document.querySelectorAll(s).forEach(function (el) {
            el.textContent = count;
          });
        });
      })
      .catch(function () {});
  }

  /* ---------- countdown ---------- */
  var timer = root.querySelector(".dbp-timer");
  if (timer) {
    var raw = (timer.getAttribute("data-deadline") || "").trim();
    var expiredMsg = timer.getAttribute("data-expired") || "No longer available.";
    var deadline = parseDeadline(raw);
    var descEl = timer.querySelector(".dbp-timer__desc");
    var labelEl = timer.querySelector(".dbp-timer__label");
    var nums = {
      d: timer.querySelector('[data-unit="d"]'),
      h: timer.querySelector('[data-unit="h"]'),
      m: timer.querySelector('[data-unit="m"]'),
      s: timer.querySelector('[data-unit="s"]'),
    };

    if (!deadline || isNaN(deadline.getTime())) {
      // no usable date — remove the timer entirely
      timer.parentNode && timer.parentNode.removeChild(timer);
    } else {
      tick();
      var iv = setInterval(tick, 1000);
    }

    function set(el, v) {
      if (el) el.textContent = v < 10 ? "0" + v : "" + v;
    }
    function tick() {
      var diff = deadline.getTime() - Date.now();
      if (diff <= 0) {
        clearInterval(iv);
        timer.classList.add("is-expired");
        if (labelEl) labelEl.textContent = "Ended";
        if (descEl) descEl.textContent = expiredMsg;
        return;
      }
      var s = Math.floor(diff / 1000);
      set(nums.d, Math.floor(s / 86400));
      set(nums.h, Math.floor((s % 86400) / 3600));
      set(nums.m, Math.floor((s % 3600) / 60));
      set(nums.s, s % 60);
    }
  }

  // Accepts "2026-09-01", "2026-09-01 18:00", "2026-09-01T18:00".
  // Treats a bare date/time as local time.
  function parseDeadline(str) {
    if (!str) return null;
    var native = new Date(str);
    if (!isNaN(native.getTime()) && /[TZ]|\d{2}:\d{2}/.test(str) === false) {
      return native; // plain YYYY-MM-DD parsed fine
    }
    var m = str.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/
    );
    if (m) {
      return new Date(
        +m[1],
        +m[2] - 1,
        +m[3],
        +(m[4] || 0),
        +(m[5] || 0),
        +(m[6] || 0)
      );
    }
    return isNaN(native.getTime()) ? null : native;
  }

  /* expose icon markup builder use (kept for clarity / future) */
  void svgIcon;
  void PLAY_PATH;
  void PAUSE_PATH;
})();